import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { ICustomerJobHistoryModel } from "@models";
import { CustomersService, LookupService } from "@services";
import { SlickScreenBlockerService } from "@slick-components";

@Component({
    selector: "job-history",
    templateUrl: "./job-history.component.html",
    styleUrls: ["./job-history.component.scss"],
    providers: [CustomersService]
})

export class JobHistoryComponent implements OnChanges {
    @Input() customerId: number;

    // The card's job name and invoice number are links. This component only says which record was
    // clicked; the host decides how it opens (the customer page uses its dialogs).
    @Output() openJob = new EventEmitter<number>();
    @Output() openInvoice = new EventEmitter<number>();

    customerJobHistory: ICustomerJobHistoryModel[];
    searchString: string = " ";

    constructor(private readonly customersService: CustomersService,
        protected readonly lookupService: LookupService,
        private readonly slickScreenBlockerService: SlickScreenBlockerService) {

    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.customerId)
            await this.refreshHistory();
    }

    // Public so the host can reload after a job or invoice is saved in a dialog over the page.
    async refreshHistory() {
        this.slickScreenBlockerService.block();
        try {
            this.customerJobHistory = await this.customersService.getCustomerJobHistory(this.customerId, this.searchString);

            // Crew names are resolved here, after the rows have arrived. This used to run right after an
            // un-awaited refresh, so it always looked at the previous list (or none) and the crew never
            // showed.
            for (const historyItem of this.customerJobHistory ?? []) {
                if (historyItem.actualCrew) {
                    const userIds: number[] = JSON.parse(historyItem.actualCrew);
                    const users = this.lookupService.getUsers(null, true)
                        .filter(x => userIds.includes(x.userId))
                        .map(u => u.fullName);
                    historyItem.crewDisplay = users.join(", ");
                }
            }
        }
        finally {
            this.slickScreenBlockerService.unblock();
        }
    }

    onSearch(searchString: string) {
        this.searchString = searchString;
        this.refreshHistory();
    }
}
